export const routingNumberLength = 9;
export const accountNumberMinLength = 4;
export const accountNumberMaxLength = 14;
export const noWhitespaceRegex = /^[^\s]*$/gm;
export const numbersOnlyRegex = /^[0-9]*$/gm;
export const abaNumberMaxLength = 9;
export const sourceAccountAccountNumberMaxLength = 20;
export const cardLast4Length = 4;
export const ssnLast4Length = 4;
export const billingZipCodeLength = 5;
